export default "__VITE_ASSET__XsXh_WwT__"